<div class="demo">
  <pa-info-block blockTitle="Одно значение (без tooltip)">
    <p class="demo__caption">
      Классический формат: подпись и одно значение, без подсказки при наведении.
    </p>
    <app-summary-cards [items]="basicItems"></app-summary-cards>
  </pa-info-block>

  <pa-info-block blockTitle="Составное значение и tooltip">
    <p class="demo__caption">
      Значение и лимит отображаются как «значение/лимит». При наведении на
      значение показывается подсказка, если она передана.
    </p>
    <app-summary-cards [items]="extendedItems"></app-summary-cards>
  </pa-info-block>
</div>
